<template>
  <div v-show="rec" ref="pop" class="ins-helppop" role="tooltip"
       :class="{ 'is-on': on, 'is-below': below, 'is-above': !below }"
       :style="{ left: x + 'px', top: y + 'px', '--hx': hx + 'px' }">
    <template v-if="rec">
      <b class="ins-hp-t">{{ rec.t }}</b>
      <div v-if="rec.d" class="ins-hp-d">{{ rec.d }}</div>
      <div v-if="rec.live" class="ins-hp-live">{{ rec.live }}</div>
      <div v-if="rec.k" class="ins-hp-k">{{ rec.k }}</div>
    </template>
  </div>
</template>

<script>
import { helpFor } from '@/utils/insightsHelp';

// Плашка подсказки под кнопкой. Системный title не годится: приходит через секунду,
// обрезается в одну строку и не умеет второй мысли «когда пригодится».
export default {
  name: 'HelpPop',
  data() {
    return { rec: null, on: false, below: true, x: 0, y: 0, hx: 18 };
  },
  mounted() {
    // Делегирование на корень страницы: кнопки перерисовываются постоянно, и вешать
    // слушатель на каждую значило бы переподключать их на каждый рендер.
    this.root = this.$el.closest('.ins-root') || document.body;
    this.el = null;      // кнопка, к которой показана или ждёт показа подсказка
    this.stash = null;   // {el, t} — снятый на время показа title
    this.timer = null;
    // pointer*, а не mouse*: Chrome не шлёт mouseover с disabled-кнопок, а у них в реестре
    // как раз «к» про недоступность (прототип 2338).
    this.root.addEventListener('pointerover', this.onOver);
    this.root.addEventListener('pointerout', this.onOut);
    // Клик, Esc и любая прокрутка прячут: после них кнопка часто уезжает,
    // и плашка висела бы в пустоте.
    document.addEventListener('click', this.hide, true);
    document.addEventListener('keydown', this.onKey, true);
    window.addEventListener('scroll', this.hide, true);
    window.addEventListener('resize', this.hide);
  },
  beforeUnmount() {
    this.hide();
    this.root.removeEventListener('pointerover', this.onOver);
    this.root.removeEventListener('pointerout', this.onOut);
    document.removeEventListener('click', this.hide, true);
    document.removeEventListener('keydown', this.onKey, true);
    window.removeEventListener('scroll', this.hide, true);
    window.removeEventListener('resize', this.hide);
  },
  methods: {
    // Кроме [data-help] — кнопки только с title (прототип 2334): плашка с надписью кнопки
    // заголовком и title строкой ниже вместо системной подсказки.
    target(node) {
      // Поля ввода с классом .btn (поиск и имя в панели сборки решётки) не цели: надписи у них нет,
      // а плашка легла бы на подсказки поиска.
      return node && node.closest ? node.closest('[data-help], .tgl[title], .btn[title]:not(input), .ins-seg-b[title], '
        + '.ins-seg-add[title], .wm-hcell[title], .wm-rname[title], .ly-f6-i[title], .ly-f6-x[title]') : null;
    },
    onOver(event) {
      const el = this.target(event.target);
      if (!el || el === this.el) return;
      this.hide();
      this.el = el;
      // title снимаем, а не выбрасываем: на уходе курсора он вернётся — его читают
      // скринридеры, и две подсказки поверх друг друга — это шум.
      if (el.hasAttribute('title')) {
        this.stash = { el: el, t: el.getAttribute('title') };
        el.removeAttribute('title');
      }
      // Задержка, чтобы плашки не мигали, пока курсор просто идёт вдоль панели.
      this.timer = setTimeout(() => this.show(el), 260);
    },
    onOut(event) {
      if (!this.el) return;
      const to = event.relatedTarget;
      if (to && this.el.contains(to)) return;
      this.hide();
    },
    // Esc только прячет плашку и дальше не глотается: тот же Esc выходит из слоёв
    // и закрывает окна A/B, как в прототипе (2358, 7645).
    onKey(event) {
      if (event.key === 'Escape') this.hide();
    },
    show(el) {
      this.timer = null;
      const rec = helpFor(el.dataset.help);
      const live = this.stash && this.stash.el === el ? this.stash.t : '';
      if (!rec && !live) return;
      const label = (el.dataset.helpLabel || el.textContent || '').trim().slice(0, 40);
      this.rec = {
        t: (rec && rec.т) || label,
        d: rec ? rec.д || '' : live,
        live: rec ? live : '',
        k: rec ? rec.к || '' : '',
      };
      this.$nextTick(() => {
        this.place(el);
        requestAnimationFrame(() => { this.on = true; });
      });
    },
    // Под кнопкой, а не под курсором: текст длинный, и за мышью его не дочитать.
    // Хвостик держится центра кнопки, даже когда плашку прижало к краю экрана.
    place(el) {
      const pop = this.$refs.pop;
      if (!pop || !el.isConnected) return;
      const r = el.getBoundingClientRect();
      const M = 8, GAP = 9;
      const w = pop.offsetWidth, h = pop.offsetHeight;
      const x = Math.max(M, Math.min(window.innerWidth - M - w, Math.round(r.left + r.width / 2 - w / 2)));
      this.below = r.bottom + GAP + h <= window.innerHeight - M;
      this.x = x;
      this.y = this.below ? r.bottom + GAP : Math.max(M, r.top - GAP - h);
      this.hx = Math.max(10, Math.min(w - 19, r.left + r.width / 2 - x - 4.5));
    },
    hide() {
      clearTimeout(this.timer);
      this.timer = null;
      if (this.stash && this.stash.el.isConnected && !this.stash.el.hasAttribute('title')) {
        this.stash.el.setAttribute('title', this.stash.t);
      }
      this.stash = null;
      this.el = null;
      this.on = false;
      this.rec = null;
    },
  },
};
</script>

<style>
/* Не scoped: плашка одна на страницу, классы с префиксом. pointer-events:none — курсор
   проходит насквозь, и кнопка под подсказкой остаётся нажимаемой. */
.ins-helppop{position:fixed; z-index:400; max-width:330px; pointer-events:none;
  background:var(--surface-1); color:var(--text-primary);
  border:1px solid var(--border); border-radius:10px; padding:9px 12px 10px;
  box-shadow:0 10px 30px var(--shadow-sm), 0 2px 6px var(--shadow-xs);
  font-size:12.5px; line-height:1.45; opacity:0; transform:translateY(-3px);
  transition:opacity .12s ease, transform .12s ease;}
.ins-helppop.is-on{opacity:1; transform:none;}
.ins-helppop .ins-hp-t{display:block; font-size:13px; font-weight:650; margin-bottom:3px;}
.ins-helppop .ins-hp-d{color:var(--text-secondary); white-space:pre-line;}
.ins-helppop .ins-hp-live{color:var(--text-muted); white-space:pre-line;}
/* «когда пригодится» — вторая мысль, поэтому отбита линией, а не просто абзацем */
.ins-helppop .ins-hp-k{margin-top:6px; padding-top:6px; border-top:1px solid var(--grid); color:var(--text-muted);}
.ins-helppop:after{content:""; position:absolute; left:var(--hx,18px); width:9px; height:9px;
  background:var(--surface-1); border-left:1px solid var(--border);
  border-top:1px solid var(--border); transform:rotate(45deg);}
.ins-helppop.is-below:after{top:-5px;}
.ins-helppop.is-above:after{bottom:-5px; transform:rotate(225deg);}
</style>
